<template>
    <UiMultiColumnsLayoutNew :blok="blok" />
</template>

<script setup lang="ts">
import type { IMultiColumnsLayout } from '@nuxt-monorepo/ui/types/components/MultiColumnsLayout';

defineProps<{ blok: IMultiColumnsLayout }>();
</script>

<style scoped lang="postcss">
.sf-multicol-layout-new > :deep(.container) {
    @apply mx-auto px-4 tracking-[1.056px] leading-5;
}

:deep(.slot) {
    @apply max-md:col-auto !important;
    .simple-image {
        @apply min-h-[var(--min-image-wrapper-height)] flex items-end;
    }
}

.multi-column-layout {
    @apply bg-transparent;
    :deep(.grid-wrapper) {
        --multicolumn-row-gap: 1rem;
        --column-gap: 1rem;
        @apply gap-x-[var(--column-gap)] gap-y-[var(--multicolumn-row-gap)];
        @media screen and (max-width: 768px) {
            --multicolumn-row-gap: 0px;
            --column-gap: 0px;
        }
    }
    :deep(&.hide-on-mobile) {
        @apply hidden md:block;
    }
    :deep(&.hide-on-desktop) {
        @apply block md:hidden;
    }
}
</style>
